import { render, staticRenderFns } from "./WordTemplates.vue?vue&type=template&id=4a0c0718&"
import script from "./WordTemplates.vue?vue&type=script&lang=js&"
export * from "./WordTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports